import { Component, inject, Input, OnInit } from '@angular/core';
import { TeamDetailsService } from '../../team-details.service';
import { ModalController } from '@ionic/angular';
import { SeasonSelectorService } from '../../../../_shared/components/season-selector/season-selector.service';
import { ToastService } from '../../../../_core/services/toast.service';
import { LoaderService } from '../../../../_core/services/loader.service';
import { Router } from '@angular/router';
import { finalize, Subject, takeUntil } from 'rxjs';
import { Season } from '../../../../_shared/models/season.model';
import { TeamAdmin } from '../../../../_shared/models/user.model';
import { Team } from '../../../../_shared/models/team.model';


@Component({
  selector: 'app-staff-list',
  templateUrl: './staff-list.component.html',
  styleUrls: ['./staff-list.component.scss'],
  standalone: false // same as ConfirmEmailComponent
})
export class StaffListComponent implements OnInit {
  @Input() teamId!: string;

  teamAdmins: TeamAdmin;
  isLoading: boolean = true;
  selectedSeason: Season;

  private readonly destroy$: Subject<void> = new Subject();
  removingAdmin: boolean;
  private modalController = inject(ModalController);
  @Input() isOwner: boolean;
  team: Team;


  constructor(
    private seasonSelectorService: SeasonSelectorService,
    private teamDetailsService: TeamDetailsService,
    private toastService: ToastService,
    private router: Router
  ) {
    this.isOwner = this.teamDetailsService.isOwner(this.team?.owners);;
  }

  ngOnInit() {
    const urlSplit = this.router.url.split('/');
    this.teamId = this.teamDetailsService?.teamInfo?._id ?? urlSplit[urlSplit.length - 2];
    this.selectedSeason = this.seasonSelectorService.season;
    this.getTeamAdmins();
  }


  dismiss() {
    this.modalController.dismiss()
  }

  nonPendingCoaches() {
    return this.teamAdmins?.coaches?.filter(c => c.status !== 'pending' && c.status !== 'verified') || [];
  }

  claimStaff(userId: string) {
    this.isLoading = true;
    if (this.teamId) {
      this.teamDetailsService
        .claimUserAsStaff(this.teamId, userId, 'coach')
        .pipe(
          takeUntil(this.destroy$),
          finalize(() => this.isLoading = false))
        .subscribe({
          next: async (res) => {
            this.isLoading = false;
            this.toastService.presentToast(res?.message)
            this.modalController.dismiss({success: true});
            //await this.getTeamOwnerStatus();
          }
        });
    }
  }

  getTeamAdmins() {
    this.isLoading = true;
    if (this.teamId) {
      this.teamDetailsService
        .getOwners(this.teamId)
        .pipe(
          takeUntil(this.destroy$),
          finalize(() => this.isLoading = false))
        .subscribe({
          next: async (res) => {
            this.isLoading = false;
            if (res?.data) {
              this.teamAdmins = res.data;
            }
          }
        });
    }
  }
}